import axios from 'axios';
import { AnyIfEmpty } from 'react-redux';
import {
    ADD_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    ADD_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
    ADD_TOUR_EXPERIENCE_MESSAGE_FAILURE,
    GET_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    GET_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
    GET_TOUR_EXPERIENCE_MESSAGE_FAILURE,
    EDIT_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    EDIT_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
    EDIT_TOUR_EXPERIENCE_MESSAGE_FAILURE,
    DELETE_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    DELETE_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
    DELETE_TOUR_EXPERIENCE_MESSAGE_FAILURE,
    REMOVE_PREVIOS_TOUR_DATA,
} from '../constants/tourExperience.constants';

const addTourMessageRequest = () => {
    return {
        type: ADD_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    };
};

const addTourMessageSuccess = (addTourData: AnyIfEmpty<object>) => {
    return {
        type: ADD_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
        payload: addTourData,
    };
};

const addTourMessageFailure = (addTourError: string) => {
    return {
        type: ADD_TOUR_EXPERIENCE_MESSAGE_FAILURE,
        payload: addTourError,
    };
};

const getTourMessageRequest = () => {
    return {
        type: GET_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    };
};

const getTourMessageSuccess = (getTourData: AnyIfEmpty<object>) => {
    return {
        type: GET_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
        payload: getTourData,
    };
};

const getTourMessageFailure = (getTourError: string) => {
    return {
        type: GET_TOUR_EXPERIENCE_MESSAGE_FAILURE,
        payload: getTourError,
    };
};

const editTourMessageRequest = () => {
    return {
        type: EDIT_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    };
};

const editTourMessageSuccess = (editTourData: AnyIfEmpty<object>) => {
    return {
        type: EDIT_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
        payload: editTourData,
    };
};

const editTourMessageFailure = (editTourError: string) => {
    return {
        type: EDIT_TOUR_EXPERIENCE_MESSAGE_FAILURE,
        payload: editTourError,
    };
};

///
const deleteTourMessageRequest = () => {
    return {
        type: DELETE_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    };
};

const deleteTourMessageSuccess = (deleteTourData: AnyIfEmpty<object>) => {
    return {
        type: DELETE_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
        payload: deleteTourData,
    };
};

const deleteTourMessageFailure = (deleteTourError: string) => {
    return {
        type: DELETE_TOUR_EXPERIENCE_MESSAGE_FAILURE,
        payload: deleteTourError,
    };
};

export const removePrevTourData = () => {
    return {
        type: REMOVE_PREVIOS_TOUR_DATA,
    };
};

export const addTourMessage = (tourMessage: any, locationId: any) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(addTourMessageRequest());
        return await axios
            .post('/tour-experience-message', tourMessage)
            .then((response) => {
                dispatch(addTourMessageSuccess(response.data));
                dispatch(getTourMessage(locationId));
                // dispatch(getLocation());
            })
            .catch((err) => dispatch(addTourMessageFailure(err.message)));
    };
};

export const getTourMessage = (locationId: string | undefined) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getTourMessageRequest());
        return await axios
            .get(`/tour-experience-message/${locationId}`)
            .then((response) => {
                dispatch(getTourMessageSuccess(response.data));
            })
            .catch((err) => dispatch(getTourMessageFailure(err.message)));
    };
};

export const editTourMessage = (id: any, tourExperienceMessages: any) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(editTourMessageRequest());

        return await axios
            .patch(`/tour-experience-message/${id}`, tourExperienceMessages)
            .then((response) => {
                dispatch(editTourMessageSuccess(response.data));
            })
            .catch((err) => dispatch(editTourMessageFailure(err.message)));
    };
};

export const deleteTourMessage = (id: any, locationid: any) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(deleteTourMessageRequest());

        return await axios
            .delete(`/tour-experience-message/${id}/${locationid}`)
            .then((response) => {
                dispatch(deleteTourMessageSuccess(response.data));
                dispatch(getTourMessage(locationid));
            })
            .catch((err) => dispatch(deleteTourMessageFailure(err.message)));
    };
};
